import { useQuery } from '@tanstack/react-query';
import { getBankAccountInfoService } from '../../user/bankAccount/infra';

export const useGetBankAccountInfo = ({
  userId,
  userType = 'clouder',
  enabled = true,
}) => {
  return useQuery({
    queryKey: ['getBankAccount', userId, userType],
    queryFn: async () => {
      const res = await getBankAccountInfoService({ userId, userType });
      return res?.data ?? res;
    },
    enabled: Boolean(userId) && enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: 0,
  });
};
